//设置根元素字体大小
document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
var deviceWidth = document.documentElement.clientWidth;
if (deviceWidth > 750) deviceWidth = 750;
document.documentElement.style.fontSize = deviceWidth / 7.5 + 'px';

// window.onload = function () {
//     console.log("onload...")
//     // 多页面通信，监控
//     window.addEventListener('storage', function (e, a) {
//         console.log(e, a)
//         // if (e.key === 'ctc-msg') {
//         //     const data = JSON.parse(e.newValue);
//         //     const text = '[receive] ' + data.msg + ' —— tab ' + data.from;
//         //     console.log('[Storage I] receive message:', text);
//         // }
//     });

//     window.onbeforeunload = function (event) {
//         var event = event || window.event;
//         // 兼容IE8和Firefox 4之前的版本
//         if (event) {
//             event.returnValue = "确定要关闭窗口吗？";
//         }
//         // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
//         return '确定要关闭窗口吗>现代浏览器？';
//     }
// }

// 百度统计
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?415cd317bde89c0fc3e5e3adb0a55218";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();



// WEBPACK FOOTER //
// ./src/global/init.js